String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

String.prototype.capitalizeWords = function () {
    var splitStr = this.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
}

String.prototype.slugToLabel = function () {
    return this.replace(/_/g, ' ').capitalizeWords().replace(' Id', ' ID');
}

String.prototype.snakeCase = function () {
    return this
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.toLowerCase())
        .join('_');
}

String.prototype.kebabCase = function () {
    return this
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.toLowerCase())
        .join('-');
}

String.prototype.camelCase = function () {
    return this
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}

String.prototype.pascalCase = function () {
    return this
        .camelCase()
        .capitalize();
}

String.prototype.plural = function () {
    return this + 's';
}

String.prototype.isEmail = function () {
    let regex = /\S+@\S+\.\S+/;
    return regex.test(this);
}

window.centsToPrice = function (cents) {
    var euros = cents / 100;
    return euros.toLocaleString("fr-FR", {style:"currency", currency:"EUR"});
};

window.getQueryParams = function (url) {
    let queryParams = {};
    let anchor = document.createElement('a');
    anchor.href = url;
    
    let queryStrings = anchor.search.substring(1);
    let params = queryStrings.split('&');
    
    for (var i = 0; i < params.length; i++) {
        var pair = params[i].split('=');
        queryParams[pair[0]] = decodeURIComponent(pair[1]);
    }

    return queryParams;
};